import { Navigate, useParams } from 'react-router-dom';

import { insightsHubCategoriesConfig } from './constants';

// The category listing was replaced by search. Old links land on a category
// listing there; anything we can't map falls back to the research hub home.
export const CategoryRedirect = () => {
  const { category } = useParams();
  const config = insightsHubCategoriesConfig.find(({ key }) => key === category);

  if (!config) {
    return <Navigate to='/research-hub' replace />;
  }

  return (
    <Navigate to={`/research-hub/search?category=${encodeURIComponent(config.key)}`} replace />
  );
};
